import { render, staticRenderFns } from "./ReporteMarcacion.vue?vue&type=template&id=29057e6a&scoped=true"
import script from "./ReporteMarcacion.vue?vue&type=script&lang=js"
export * from "./ReporteMarcacion.vue?vue&type=script&lang=js"
import style0 from "./ReporteMarcacion.vue?vue&type=style&index=0&id=29057e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29057e6a",
  null
  
)

export default component.exports